import styles from "./ModelsGrid.module.scss";
import { ModelLibraryCard } from "../model-library-card";
import type { ModelsLibraryItem } from "../../_types/content-models.types";

type ModelsGridProps = {
  models: ModelsLibraryItem[];
  loading?: boolean;
};

export const ModelsGrid = ({ models, loading }: ModelsGridProps) => {
  if (loading) {
    return (
      <div className={styles["comp"]}>
        <div className={styles["comp__empty"]}>Loading catalog…</div>
      </div>
    );
  }

  if (models.length === 0) {
    return (
      <div className={styles["comp"]}>
        <div className={styles["comp__empty"]}>No models match this filter.</div>
      </div>
    );
  }

  return (
    <div className={styles["comp"]}>
      {models.map((model) => (
        <ModelLibraryCard key={model.slug} model={model} />
      ))}
    </div>
  );
};
